export const ssl = true;
export const hostname = "app.floweryai.com";
export const port = null;
